import { useNavigate, useSearchParams } from 'react-router-dom';

const Faq = () => {
    const navigate = useNavigate();

    return (
        <div class="main-faq">
            <h2 class="tit">FAQ</h2>
            <div class="main-faq-bd">
                <button
                    type="button"
                    class="itm"
                    onClick={() => {
                        navigate('/support/faq?type=homePage');
                    }}
                >
                    <span>홈페이지 회원</span>
                </button>
                <button
                    type="button"
                    class="itm"
                    onClick={() => {
                        navigate('/support/faq?type=receipt');
                    }}
                >
                    <span>접수</span>
                </button>
                <button
                    type="button"
                    class="itm"
                    onClick={() => {
                        navigate('/support/faq?type=application');
                    }}
                >
                    <span>응시</span>
                </button>
                <button
                    type="button"
                    class="itm"
                    onClick={() => {
                        navigate('/support/faq?type=cert');
                    }}
                >
                    <span>자격제도</span>
                </button>
                <button
                    type="button"
                    class="itm"
                    onClick={() => {
                        navigate('/support/faq?type=etc');
                    }}
                >
                    <span>기타</span>
                </button>
            </div>
        </div>
        // <div className="main-faq">
        //     <h2>FAQ</h2>
        //     <ul>
        //         <li>
        //             <a href="/m/support/faq?type=homePage">
        //                 홈페이지
        //                 <br />
        //                 회원<i className="i-member"></i>
        //             </a>
        //         </li>
        //         <li>
        //             <a href="/m/support/faq?type=receipt">
        //                 접수<i className="i-accept"></i>
        //             </a>
        //         </li>
        //         <li>
        //             <a href="/m/support/faq?type=application">
        //                 응시<i className="i-exam"></i>
        //             </a>
        //         </li>
        //         <li>
        //             <a href="/m/support/faq?type=cert">
        //                 자격제도<i className="i-license"></i>
        //             </a>
        //         </li>
        //         <li>
        //             <a href="/m/support/faq?type=etc">
        //                 기타<i className="i-etc"></i>
        //             </a>
        //         </li>
        //     </ul>
        // </div>
    );
};

export default Faq;
